<template>
  <div class="container px-14 lg:px-50 xl:px-20 pt-32 pb-28">
    <ol class="leading-1.25 flex flex-wrap items-center">
      <li v-for="([text, url], index) in breadcrumbs" class="flex text-sm">
        <a v-if="url" class="link link-accent text-sm" :href="url">
          {{ text }}
        </a>
        <p v-else class="text-dark-gray">
          {{ text }}
        </p>
        <span
          v-if="index !== breadcrumbs.length - 1"
          class="after-content-fslash text-dark-gray"
        ></span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: [],
    };
  },

  created() {
    this.breadcrumbs = jsonFromPage("#data-breadcrumbs");

    // Register the component globally so it can be modified by other components.
    window.TheBreadcrumb = this;
  },

  methods: {
    replaceLast(text) {
      this.breadcrumbs.pop();
      this.breadcrumbs.push([text]);
    },

    replace(breadcrumbs) {
      this.breadcrumbs = breadcrumbs;
    },
  },
};
</script>
